import { v4 } from 'uuid';
import * as turf from '@turf/turf';

const buffer = 10; // pixels

function isValidJSON(str) {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}

const getRenderedFeatures = (point, map) => {
    return map.queryRenderedFeatures( [
        [point.x - buffer, point.y - buffer],
        [point.x + buffer, point.y + buffer],
    ]);
};

export const handleMapInteraction = (
    point,
    map,
    draw,
    setCurrentPoint,
    setShowDetails,
    setOpenReviewDetails,
    setDetailsData,
    ruler

) => {
    if (ruler.isActive) {
        return;
    }
    if (draw?.getMode() === 'draw_point') {
        return;
    }

    const features = getRenderedFeatures(point, map);

    const results = {};


    for (const feature of features) {
        const layerId = feature?.layer?.id;
        const { properties, geometry } = feature;


        if (layerId === 'gl-draw-point-active.hot') {
            setCurrentPoint(properties);
            setShowDetails(false);
            setOpenReviewDetails(true);
            return;
        }



        const layerConfig = {
            _baseBackground: { icon: 'c', substringLength: 15 },
            _baseBackgroundPattern_pattern: { icon: 'c', substringLength: 30 },
            _overlayBackground: { icon: 'c', substringLength: 18 },
            _overlayBorder: { icon: 'b', substringLength: 14 },
            _baseBorder: { icon: 'b', substringLength: 11 },
            _icon: { icon: 'a', substringLength: 5 },
        };

        Object.keys(layerConfig).forEach((key) => {
            if (new RegExp(`${key}$`).test(layerId)) {
                const obj = properties;

                Object.keys(obj).forEach(key => {
                    // convert json objects
                    if (isValidJSON(obj[key])) {
                        obj[key] = JSON.parse(obj[key]);
                    }
                });



                delete properties['_attributes'];
                const layerType = layerId?.substring(0, layerId?.length - layerConfig[key].substringLength);

                if (!results[layerType]) {

                    results[properties?.type] = {
                        type: properties?.type,
                        id: properties?.id,
                        layerId:layerId,
                        name: properties?.label,
                        data: properties,
                        icon: layerConfig[key].icon,
                        boundary: turf.bbox(geometry)
                    };
                }
            }
        });
    };

    // prevent Details slider to open if I click outside a polygon
    if(Object.keys(results).length > 0) {
        setDetailsData(results);
        setShowDetails(true);
    }
};

export const handleMapSelectChange = (e) => {
    const selectedFeatures = e.features;
    if (selectedFeatures.length > 0) {
        selectedFeatures.forEach((feature) => {
            if (feature.geometry.type === 'Polygon') {
                //console.log('here Add');
            }
        });
    }
};

export const handleDrawCreate = (e, setCurrentPoint, setShowDetails, setOpenReviewCreate, draw, setIsDrawing) => {
    const point = {
        id:v4(),
        location: e?.features?.[0]
    };
    setIsDrawing(true);
    setCurrentPoint(point)
    draw.delete(e.features[0].id);
    setShowDetails(false);
    setOpenReviewCreate(true);
}

export const handleDrawUpdate = (setShowDetails, setOpenReviewCreate) => {
    setShowDetails(false);
    setOpenReviewCreate(false);
}

export const handleDrawDelete = (setOpenReviewDetails, setShowDetails, setOpenReviewCreate) => {
    setOpenReviewDetails(false);
    setShowDetails(false);
    setOpenReviewCreate(false);
}

export const handleDrawModeChange = (e, draw, isDrawing, setIsDrawing) => {
    if (isDrawing) {
        draw.changeMode('draw_point');
        setIsDrawing(false);
    }
}


export const toggle3d = (map) => {
    const visibility = map.getLayoutProperty('3d-buildings', 'visibility');

    if (visibility === 'visible') {
        map.easeTo({ pitch: 0 });
        map.setLayoutProperty('3d-buildings', 'visibility', 'none');
        map.setLayoutProperty('xplan:BP_BaugebietsTeilFlaeche3d-extrude', 'visibility', 'none');
        map.setLayoutProperty('xplan:BP_BaugebietsTeilFlaeche_background', 'visibility', 'visible');
    } else {
        map.easeTo({ pitch: 45 });
        map.setLayoutProperty('3d-buildings', 'visibility', 'visible');
        map.setLayoutProperty('xplan:BP_BaugebietsTeilFlaeche3d-extrude', 'visibility', 'visible');
    }
}



export const handleZoomToLayer = async (boundary,map) => {
    await map.fitBounds(boundary,{
        padding: {top: 100, bottom:50, left: 50, right: 50},
        duration: 0
    });
    return true;
};


export const handleLayerBlink = ( layerId, featureId, map, layerBlink, setLayerBlink) => {
    if (layerBlink) {
        return;
    }
    setLayerBlink(true);

    const layer = layerId?.replace('_baseBackgroundPattern_pattern','_baseBorder').replace('_baseBackground','_baseBorder').replace('_overlayBackground','_overlayBorder');

    const featureFilter = ['all', ['==', ['get', 'id'], featureId]];
    const originalColor = map.getPaintProperty(layer, "line-color");
    const originalWidth = map.getPaintProperty(layer, "line-width");

    map.setFilter(layer, featureFilter);
    map.setPaintProperty(layer, "line-color", "#c200ff");
    map.setPaintProperty(layer, "line-width",10);

    setTimeout(() => {
        map.setPaintProperty(layer, "line-color", originalColor);
        map.setPaintProperty(layer, "line-width", originalWidth);
        setTimeout(() => {
            map.setFilter(layer, null);
            setLayerBlink(false);
        }, 200);
    }, 1000);
}